<div class="flex" style="position:relative;width: 100%; height: 100%;">
    <div id="forge-viewer"></div>
</div>
